export const PIN_VISIBILITY_STORAGE_KEY = {
  competitorsMap: 'map.pinVisibility.competitors',
  addressMap: 'map.pinVisibility.address',
  projectDirectionsMap: 'map.pinVisibility.projectDirections',
} as const;

export type PinVisibilityStorageKey =
  (typeof PIN_VISIBILITY_STORAGE_KEY)[keyof typeof PIN_VISIBILITY_STORAGE_KEY];

// Clusters stack at 1000 + count, so the map's own subject pin takes the CSS
// maximum to stay visible over any of them.
export const ABOVE_CLUSTERS_Z_INDEX = 2_147_483_647;
